export function redirectToError(router, status, next = null) {
    let queryParams: any = { status: status }
    if (next) {
        queryParams.next = next
    }
    router.navigate(["error"], {
        queryParams: queryParams,
        queryParamsHandling: "merge",
        skipLocationChange: true,
    })
}

export function getDRFErrorMessages(
    errorResponse,
    fields: string[] = []
): string[] {
    if (!errorResponse || !errorResponse.error) {
        return []
    }
    let errors = []
    if (errorResponse.error.non_field_errors) {
        errors = errorResponse.error.non_field_errors
    }
    fields.forEach((field) => {
        if (errorResponse.error[field]) {
            errors.push(errorResponse.error[field])
        }
    })
    return errors
}
